import { AnyObj } from '@weapp/ui';
import { qs } from '@weapp/utils';
import ebdcoms from '../../../utils/ebdcoms';

export const getCrmCustomModule = (type: string) => {
  const { SystemPageType } = ebdcoms.get();
  const {
    CustomerIdentification,
    ImportCustomer,
    BatchEditCustomer,
    ImportContactReminder,
    ContactIdentification,
    ImportContact,
    ImportContactRecord,
    BatchEditOpportunities,
    BatchEditClues,
  } = SystemPageType;
  switch (type) {
    case CustomerIdentification:
    case ImportCustomer:
    case BatchEditCustomer:
      return 'customer';
    case ImportContact:
    case ContactIdentification:
      return 'contact';
    case ImportContactRecord:
      return 'customerComment';
    case ImportContactReminder:
      return 'customerRemind';
    case BatchEditOpportunities:
      return 'saleChance';
    case BatchEditClues:
      return 'clue';
    default:
      return '';
  }
};

// 判断是否是登陆前页面 true 为登陆前页面
export function isPassportEbpage() {
  return window?.EBUILDER?.pageInfo?.module === 'LOGIN_PAGE' || window?.inPassportEbpage;
}

export const getDefaultPageSdk = (compId?: string) => {
  if (compId && window?.ebuilderSDK?.pageSDKs) {
    const curPageId = Object.keys(window?.ebuilderSDK?.pageSDKs)?.find(
      // eslint-disable-next-line max-len
      (key: string) => !!window?.ebuilderSDK?.pageSDKs?.[key]?.coms?.find((com: AnyObj) => com?.id === compId),
    );
    return window.ebuilderSDK?.getPageSDK(curPageId);
  }
  return window.ebuilderSDK?.getPageSDK();
};

export const getLinkInfo = (link: string) => {
  const [linkPath, queryParams] = link?.split('?');
  return [linkPath, qs.parse(queryParams || '')] as [string, AnyObj];
};

export default {};
